import { api } from './client'

export interface AuditChange {
  field: string
  field_label: string
  old: string
  new: string
}

export interface AuditEntry {
  id: number
  entity_type: string
  entity_id: string
  user_id: string | null
  action: string
  action_label: string
  field_name: string | null
  old_value: unknown
  new_value: unknown
  created_at: string
  // Глобальный журнал — дополнительные поля
  category?: string
  entity_name?: string
  changes?: AuditChange[]
  user_name?: string | null
  user_email?: string | null
  ip_address?: string | null
}

export interface AuditFilters {
  category?: string
  user_id?: string
  limit?: number
  offset?: number
}

export const auditApi = {
  getProjectHistory: (projectId: string, limit = 100) =>
    api.get<AuditEntry[]>(`/audit/projects/${projectId}`, { params: { limit } }),

  getGlobal: (filters: AuditFilters = {}) => {
    const params: Record<string, string | number> = {}
    if (filters.category) params['category'] = filters.category
    if (filters.user_id)  params['user_id']  = filters.user_id
    if (filters.limit)    params['limit']    = filters.limit
    if (filters.offset)   params['offset']   = filters.offset
    return api.get<AuditEntry[]>('/audit/global', { params })
  },
}
